import type { CSSProperties } from 'react';

import type { TableTone } from '../../domain/floorPlan/tableIndicator';

// Оттенок иконки стола, открытого для гостей
export const GUEST_OPEN_ICON_STYLE: CSSProperties = { filter: 'hue-rotate(95deg) saturate(3.2) brightness(1.05)' };

// Цвет цифры занято/всего рядом со столом
export const TABLE_TONE_TEXT: Record<TableTone, string> = {
  default: 'var(--color-fire-600)',
  open: 'var(--color-success-600)',
  private: 'var(--color-info-600)',
  full: 'var(--color-danger-500)',
};
